import type React from "react"
import { useTranslation } from "react-i18next"

import { HStack } from "@/nzds/layout"

import { PerformanceTierIcon } from "./performance-tier-icon"
import type { PerformanceTierProps } from "./performance-tier.types"

/**
 * A component for displaying the performance tier of a site
 *
 * ```tsx
 * import { PerformanceTier } from "@/components/performance/performance-tier"
 *
 * <PerformanceTier tier="atBenchmark" />
 * ```
 */
export const PerformanceTier: React.FC<PerformanceTierProps> = ({ tier }) => {
  const { t } = useTranslation()

  return (
    <HStack sx={{ alignItems: "center", gap: 0.5 }}>
      <PerformanceTierIcon tier={tier} />
      {t(`performance.tier.${tier}`, { ns: "sites" })}
    </HStack>
  )
}
